var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproveShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.719 68.2069C382.319 68.2067 327.641 48.7742 283.89 13.181C262.289 -4.39366 231.318 -4.39366 209.716 13.181C165.966 48.7746 111.289 68.2072 54.8886 68.2069C37.2768 68.2069 23 82.4837 23 100.096V185.561C23 295.201 72.3699 399.012 157.419 468.205L183.669 489.561C220.443 519.48 273.167 519.48 309.942 489.561L336.191 468.205C421.24 399.013 470.611 295.197 470.611 185.557V100.088C470.607 82.4767 456.331 68.2069 438.719 68.2069Z",
    fill: "url(#paint0_linear_140_38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248 483.863C241.833 483.856 235.856 481.732 231.069 477.845L180.864 437C144.193 407.165 114.078 368.83 93.7745 326.138C73.4712 283.446 62.7393 235.892 62.7393 188.619V120.796C62.7393 112.591 69.4475 105.613 77.6415 105.181C133.517 102.226 187.535 81.5062 231.069 46.0878C235.856 42.201 241.833 40.0766 248 40.0703C254.166 40.0763 260.144 42.2003 264.931 46.0868C308.467 81.5062 362.486 102.226 418.361 105.181C426.553 105.613 433.261 112.59 433.261 120.794V188.615C433.261 235.889 422.529 283.443 402.225 326.136C381.922 368.83 351.807 407.165 315.137 437L264.931 477.845C260.144 481.733 254.167 483.857 248 483.863Z",
    fill: "url(#paint1_linear_140_38)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248 465.139C242.354 465.133 236.881 463.188 232.497 459.63L186.529 422.232C152.953 394.915 125.379 359.814 106.789 320.725C88.1997 281.636 78.3733 238.095 78.3733 194.81V132.711C78.3733 125.198 84.5153 118.81 92.0176 118.413C143.177 115.707 192.638 96.7361 232.497 64.3064C236.881 60.7477 242.354 58.8024 248 58.7959C253.646 58.8015 259.118 60.7466 263.501 64.3054C303.363 96.7361 352.824 115.707 403.984 118.413C411.486 118.809 417.626 125.196 417.626 132.708V194.805C417.626 238.09 407.8 281.631 389.211 320.722C370.621 359.813 343.047 394.914 309.471 422.231L263.501 459.629C259.119 463.188 253.646 465.134 248 465.139Z",
    fill: "url(#paint2_linear_140_38)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248 385.479C321.191 385.479 380.525 326.146 380.525 252.954C380.525 179.763 321.191 120.43 248 120.43C174.809 120.43 115.475 179.763 115.475 252.954C115.475 326.146 174.809 385.479 248 385.479Z",
    fill: "url(#paint3_linear_140_38)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_140_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.883 317C212.949 317 203.609 312.808 196.585 305.196L164.96 270.927C158.347 263.761 158.347 252.143 164.96 244.977C171.572 237.811 182.294 237.811 188.907 244.977L220.533 279.247C221.338 280.119 222.255 280.302 222.883 280.302C223.51 280.302 224.428 280.119 225.232 279.247L309.093 188.374C315.706 181.209 326.427 181.209 333.04 188.374C339.653 195.54 339.653 207.158 333.04 214.324L249.18 305.196C242.156 312.808 232.817 317 222.883 317Z",
    fill: "url(#paint4_linear_140_38)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_140_38",
    x: 160,
    y: 182,
    width: 191,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_140_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_140_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_38",
    x1: 64.3032,
    y1: 34.9995,
    x2: 372.303,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#073C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B578D",
    stopOpacity: 0.972549
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_140_38",
    x1: 499.854,
    y1: 469.685,
    x2: 158.348,
    y2: 128.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#93CEF6",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#6ABFEC",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#51B5E5",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_140_38",
    x1: 181.971,
    y1: 155.527,
    x2: 331.987,
    y2: 305.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_140_38",
    x1: 186.36,
    y1: 191.316,
    x2: 314.096,
    y2: 319.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DDD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ACC1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_140_38",
    x1: 215.193,
    y1: 193.015,
    x2: 309.41,
    y2: 279.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFD4DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveShield);
export default __webpack_public_path__ + "static/media/ApproveShield.fbb2de1409ae3ac3283f702ee90d5bce.svg";
export { ForwardRef as ReactComponent };